import service from './api.services';

const obterRegionais = async (idMunicipio) => {
    const response = await service.get('api/regiao/listar', {
        params: { idMunicipio }
    });
    return response.data.map(nome => ({ id: nome, nome: nome }));
};

const listarMunicipios = async (regional) => {
    const response = await service.get('/api/regiao/municipios', {
        params: { regional }
    });

    return response.data;
};

export {
    obterRegionais,
    listarMunicipios
};